import { store } from '@/store/store'
import { CardListType } from '@/types/page'

import { INIT_STORE } from './types'

export type InitStoreActionType = {
  payload: { cardLists: CardListType[] }
  type: typeof INIT_STORE
}

export const initStore = (cardLists: CardListType[]) => {
  const dispatch = store.dispatch
  dispatch({
    payload: { cardLists },
    type: INIT_STORE,
  })
}
